import { apiClient } from '../../../services/api/client';

export const departmentsAPI = {
  // Get all departments
  getAllDepartments: (params = {}) =>
    apiClient.get('/api/v1/ac/departments/', { params }),
  
  // Create department
  createDepartment: (data) =>
    apiClient.post('/api/v1/ac/departments/', data),
  
  // Get department by ID
  getDepartmentById: (departmentId) =>
    apiClient.get(`/api/v1/ac/departments/${departmentId}`),
  
  // Update department
  updateDepartment: (departmentId, data) =>
    apiClient.put(`/api/v1/ac/departments/${departmentId}`, data),
  
  // Delete department
  deleteDepartment: (departmentId) =>
    apiClient.delete(`/api/v1/ac/departments/${departmentId}`),
  
  // Make the department the one that manages the global files (only one does), or stop it
  setGlobalFilesDepartment: (departmentId, managesGlobalFiles) =>
    apiClient.put(`/api/v1/ac/departments/${departmentId}/global-files`, { manages_global_files: managesGlobalFiles }),

  // Deactivate department
  deactivateDepartment: (departmentId) =>
    apiClient.post(`/api/v1/ac/departments/${departmentId}/deactivate`),
  
  // Get active departments
  getActiveDepartments: () =>
    apiClient.get('/api/v1/ac/departments/active'),
  
  // Get deactivated departments
  getDeactivatedDepartments: () =>
    apiClient.get('/api/v1/ac/departments/deactivated'),
  
  // Get department modules
  getDepartmentModules: (departmentId) =>
    apiClient.get(`/api/v1/ac/departments/${departmentId}/modules/`),
  
  // Get current user's department modules
  getMyDepartmentModules: () =>
    apiClient.get('/api/v1/ac/departments/me/modules'),

  // Get current user's department modules with permissions (bulk, avoids N+1)
  getMyDepartmentModulesWithPermissions: () =>
    apiClient.get('/api/v1/ac/departments/me/modules-with-permissions'),
  
  // Enable module for department
  enableModule: (departmentId, moduleId) =>
    apiClient.post(`/api/v1/ac/departments/${departmentId}/modules/${moduleId}/enable`),
  
  // Disable module for department
  disableModule: (departmentId, moduleId) =>
    apiClient.delete(`/api/v1/ac/departments/${departmentId}/modules/${moduleId}`),

  resetOverdueTasks: (departmentId) =>
    apiClient.post(`/api/v1/task-management/admin/tasks/${departmentId}/reset-overdue`),
};